import React from 'react';
import styles from './form-components.module.scss';

interface FormSectionProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * FormSection - Standardized spacing wrapper for form fields
 * Provides consistent margin-bottom spacing between form elements
 */
export const FormSection: React.FC<FormSectionProps> = ({ children, className }) => {
  const combinedClassName = className ? `${styles.formSection} ${className}` : styles.formSection;
  
  return (
    <div className={combinedClassName}>
      {children}
    </div>
  );
};

export default FormSection;